module.exports = __webpack_public_path__ + "static/media/no2.acf6a759.svg";